const { detect } = require('detect-browser');
const browser = detect();

// This is the plugin object. It can be exported to be used anywhere.
const Creo = {

  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {

    // Assign our prototype functionality into all components (this.$creo).
  	Vue.prototype.$creo = {
      browserPdfLink(org, fallback, page) {
        var bName = browser.name;
        if(bName === 'chrome' || bName === 'opera' || bName === 'firefox') {
          return org + '#page=' + page;
        }
				else {
          return fallback;
        }
      }
    }

  }
};

export default Creo;



// WEBPACK FOOTER //
// ./src/plugins/creo.js